//Angular
import { Component, OnInit,ChangeDetectionStrategy, ViewEncapsulation, ViewContainerRef, Compiler, Inject, Renderer } from "@angular/core";

//Services
import { RecoverPasswordService } from "./../../../../services/cms/recover-password.service";
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { LanguageService } from "./../../../../services/cms/language.service";
import { SeoService } from "./../../../../services/core/seo.service";
import { ScriptService } from "./../../../../services/cms/script.service";
import { BreadcrumbsService } from '../../../../services/cms/breadcrumbs.service';
import { CmsComponentService } from "./../../../../services/cms/cms-component.service";
//Models
import { SeoViewModel } from "./../../../../models/core/seo";
import { RoutesService } from "../../../../services/core/routes.service";
import { Breadcrumbs } from '../../../../models/cms/breadcrumbs';

import { Subscription } from 'rxjs/Subscription';
import { DOCUMENT } from "@angular/platform-browser";

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    template: ""
})

export class UserPasswordComponent implements OnInit {

    constructor
        (
            private _compiler: Compiler,
            private componentHelper: ComponentHelperService,
            private _elementRef: ViewContainerRef,
            private recoverPasswordService: RecoverPasswordService,
            private languageService: LanguageService,
            private cmsComponentService: CmsComponentService,
            @Inject('isBrowser') private isBrowser: boolean,
            private seo: SeoService,
            private renderer: Renderer,
            @Inject(DOCUMENT) private document: any,
            private scriptService: ScriptService
        ) { }

    lang: string = this.languageService.getLongLang();

    subManager = new Subscription();
    ngOnInit() {
        let header: any;
        
        let headDataSub = this.cmsComponentService.getHeaderData().subscribe(result => {
            header = result;
            let SideMenuData = this.cmsComponentService.getSideMenuData().subscribe(result1 => {
                if (result1.Categories) {
                    header.Categories = result1.Categories;

                }
            });
            this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        let recoverPassSub = this.recoverPasswordService.getRecoverPasswordData(this.lang).subscribe(result => {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
          
            if (this.isBrowser) {
                //Creating subcomponent whith the result  to inject
                let subComponent = this.createSubComponent(result, header);

                //injecting created component (OK)
                this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
            }
            else {
                //-- Get head and body scripts
                this.scriptService.setupExternalScripts(result, this.scriptService.typeSystemPage, this.scriptService.userRecoverPasswordId);

                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                this.seo.setSeoMetaData(this.document, this.renderer, result.SeoInformation)
                this.seo.generateSeoDomServerSide(this.document, this.renderer, result.SeoInformation);
            }
        });
        this.subManager.add(recoverPassSub);

    }

    ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    }

    private createSubComponent(result: any,header:any) {
        @Component({
            template: result.TemplateHtml
        })

        class ChildComponent implements OnInit {
            constructor
                (
                    private recoverPasswordService: RecoverPasswordService,
                    private seoService: SeoService,
                    @Inject('isBrowser') private isBrowser: boolean,
                    private _elementRef: ViewContainerRef,
                    private scriptService: ScriptService,
                    private routesService: RoutesService,
                    private breadcrumbsService: BreadcrumbsService
                ) { }

            private recoverPasswordFailed: boolean = false;
            private recoverPasswordSuccess: boolean = false;
            private seoInfo: SeoViewModel = result.SeoInformation;
            private pageIsInit: boolean = false;
            private breadcrumbs: Breadcrumbs[] = result.BreadcrumbsInfo;
            private showSpinnerClick: boolean = false;
            footerData: any = result.footerData;
            headerData: any = header;
            


            private model =
                {
                    Email: ""
                };

            subManager = new Subscription();

            ngOnInit() {
                //this.headerData.Categories=SideMenu.Categories;
                this.breadcrumbsService.setBreadcrumbs(this.breadcrumbs)
                //setTimeout(x => , 1);
            }

            onSubmit(form) {
                if (form.valid) {
                    this.showSpinnerClick=true;
                    let recoverPassSub = this.recoverPasswordService.recoverPasswordRequest(this.model.Email).subscribe(result => {
                        if (result.selected) {
                            this.recoverPasswordFailed = false;
                            this.recoverPasswordSuccess = true;
                        }
                        else {
                            this.recoverPasswordFailed = true;
                            this.recoverPasswordSuccess = false;
                        }
                        this.showSpinnerClick=false;
                    });

                    this.subManager.add(recoverPassSub);
                }
            }

            ngAfterViewChecked() {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);

                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();

                this.pageIsInit = true;
            }

            ngOnDestroy() {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/settings/user/sys/user-password.component.ts